import mockData from './mockData/mockDataSources.json';

export const getDataSources = () => {
  return mockData;
};
